import { createContext } from "react";

const AffContext = createContext({
  aff : null,
  setAff : () => {}
});



export { AffContext };